module.exports = __webpack_public_path__ + "img/maintel-logo-coloured-72DPI.3b446975.png";